import InvoiceDetail from "./InvoiceDetail";
import Payment from "./Payment";
import {Link, Redirect} from 'react-router-dom';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import 'react-select/dist/react-select.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-activity/dist/react-activity.css';
import '../../../node_modules/flatpickr/dist/themes/material_blue.css';
import '../../common/webar_flatpickr.css';
import {getSelectedPrimaryAccount} from "./Selectors";
import {faAngleDoubleLeft} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export class PaymentPageComponent extends Component {

  render() {
    return <div className="container">
      <div className="row">
        {/* we duplicate this heading section for response purposes*/}
        <div className="d-flex flex-wrap d-sm-none">
          <div className="col-12">
            <h2 className="invoicesHeading">
              Invoices ({
              Object.keys(this.props.selectedInvoices).length
            }){' '}
            </h2>
          </div>
          <div className="col-12">
            <h2 className="invoicesHeading">
              Make Payments
            </h2>
          </div>
          <div className="col-12">
            <Link
              id="closeDetails"
              to={"/invoices"}
              className="btn btn-primary buttonColor"
            >
              {' '}
              <FontAwesomeIcon icon={faAngleDoubleLeft} />Back To List{' '}
            </Link>
          </div>
        </div>
        <div className="d-none d-sm-flex full-width">
          <div className="col-sm-4">
            <h2 className="invoicesHeading">
              Invoices ({
              Object.keys(this.props.selectedInvoices).length
            }){' '}
            </h2>
          </div>
          <div className="col-sm-4 text-center">
            <h2 className="invoicesHeading">
              Make Payments
            </h2>
          </div>
          <div className="col-sm-4 text-right">
            <Link
              id="closeDetails"
              to={"/invoices"}
              className="btn btn-primary buttonColor"
            >
              {' '}
              <FontAwesomeIcon icon={faAngleDoubleLeft} /> Back To List{' '}
            </Link>
          </div>
        </div>
      </div>
      <br/>
      <div className="row">
        <div className="col-12">
          <div className="card" id="mainCard">
            <div>
              {Object.keys(this.props.selectedInvoices)
                .map((key, index) => (
                  <div key={key}
                    className="checkout-invoice-detail">
                    <InvoiceDetail documentId={key}/>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <br/>
      <div className="row">
        <div className="col-12">
          <Payment/>
        </div>
      </div>
      {Object.keys(this.props.selectedInvoices).length === 0 && <Redirect to={"/invoices"}/>}
    </div>
  }
}

export default connect((store, props) => ({
  selectedInvoices: store.invoice.selected,
  secondaryAccounts: store.user_options.secondaryAccounts,
  selectedPrimaryAccount: getSelectedPrimaryAccount(store, props),
  userCustomerDetails: store.user_options.primaryAccounts,
}))(PaymentPageComponent);
